import { EChartsCoreOption } from "echarts/core";
import { ParametrosGraficoMatriculasPorAreaLocalidade, ParametrosGraficoMatriculasPorTurno, ParametrosGraficoTotalMatriculas } from "./relatorio-financiamento-das-escolas.component";
import { ResultadoEtapa1NumerosDeMatriculasDto } from "../../dtos";
import { ResultadoMatriculasPorEtapa } from "../../dtos/resultado-matriculas-etapa";

type ResultadoMatriculasEtapaCompativel = ResultadoEtapa1NumerosDeMatriculasDto | ResultadoMatriculasPorEtapa;

export class FabricaGraficosRelatorioFinanciamentoEscolas {
    static crieConfiguracaoGraficoTotalMatriculas(parametros: ParametrosGraficoTotalMatriculas,
        totalMatriculas: number,
        isCrechePorIdadeHabilitada: boolean = false
    ): EChartsCoreOption {
        const xAxisData = isCrechePorIdadeHabilitada
            ? ['creche\n(<1 ano)', 'creche\n(1 ano)', 'creche\n(2 anos)', 'creche\n(3 anos)', 'pré-\nescola', 'EF-anos\niniciais', 'EF-anos\nfinais', 'ensino\nmédio', 'EJA']
            : ['creche', 'pré-\nescola', 'EF-anos\niniciais', 'EF-anos\nfinais', 'ensino\nmédio', 'EJA'];
        const seriesData = isCrechePorIdadeHabilitada
            ? [
                { value: this.calculePorcentagem(parametros.creche0, totalMatriculas), tooltipTotal: `${parametros.creche0}` },
                { value: this.calculePorcentagem(parametros.creche1, totalMatriculas), tooltipTotal: `${parametros.creche1}` },
                { value: this.calculePorcentagem(parametros.creche2, totalMatriculas), tooltipTotal: `${parametros.creche2}` },
                { value: this.calculePorcentagem(parametros.creche3, totalMatriculas), tooltipTotal: `${parametros.creche3}` },
                { value: this.calculePorcentagem(parametros.preEscola, totalMatriculas), tooltipTotal: `${parametros.preEscola}` },
                { value: this.calculePorcentagem(parametros.ensFunAnosIniciais, totalMatriculas), tooltipTotal: `${parametros.ensFunAnosIniciais}` },
                { value: this.calculePorcentagem(parametros.ensFunAnosFinais, totalMatriculas), tooltipTotal: `${parametros.ensFunAnosFinais}` },
                { value: this.calculePorcentagem(parametros.ensMedio, totalMatriculas), tooltipTotal: `${parametros.ensMedio}` },
                { value: this.calculePorcentagem(parametros.eja, totalMatriculas), tooltipTotal: `${parametros.eja}` },
            ]
            : [
                { value: this.calculePorcentagem(parametros.creche, totalMatriculas), tooltipTotal: `${parametros.creche}` },
                { value: this.calculePorcentagem(parametros.preEscola, totalMatriculas), tooltipTotal: `${parametros.preEscola}` },
                { value: this.calculePorcentagem(parametros.ensFunAnosIniciais, totalMatriculas), tooltipTotal: `${parametros.ensFunAnosIniciais}` },
                { value: this.calculePorcentagem(parametros.ensFunAnosFinais, totalMatriculas), tooltipTotal: `${parametros.ensFunAnosFinais}` },
                { value: this.calculePorcentagem(parametros.ensMedio, totalMatriculas), tooltipTotal: `${parametros.ensMedio}` },
                { value: this.calculePorcentagem(parametros.eja, totalMatriculas), tooltipTotal: `${parametros.eja}` },
            ];
        return {
            tooltip: {
                trigger: 'item',
                backgroundColor: 'rgba(38, 38, 38, 1)',
                textStyle: {
                    color: '#fff',
                },
                padding: [2, 10, 2, 10],
                borderRadius: 10,
                borderColor: 'rgba(38, 38, 38, 1)',
                formatter: (parametro: any) => {
                    return `${parametro.name}
                        ${this.formateValor(parametro.data.tooltipTotal)} (${this.formateValor(parametro.value)}%)`;
                },
            },
            xAxis: {
                type: 'category',
                axisTick: { show: false },
                data: xAxisData,
                axisLabel: {
                    interval: 0,
                    fontSize: 12,
                },
                axisLine: {
                    show: false
                }
            },
            yAxis: {
                show: false
            },
            barGap: '30%',
            barCategoryGap: '20%',
            series: [
                {
                    barWidth: '70%',
                    name: 'Direct',
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top',
                        formatter: (data: any) => {
                            return data.value > 0 ? `${this.formateValor(data.value)}%` : '';
                        },
                        fontSize: 12,
                        color: 'rgba(54, 185, 250, 1)',
                    },
                    itemStyle: {
                        color: 'rgba(54, 185, 250, 1)',
                        borderRadius: [5, 5, 5, 5],
                    },
                    data: seriesData,
                }
            ],
            grid: {
                backgroundColor: 'transparent'
            }
        };
    }

    static crieConfiguracaoGraficoMatriculasPorAreaLocalidade(parametros: ParametrosGraficoMatriculasPorAreaLocalidade,
        resultadoEtapa1: ResultadoMatriculasEtapaCompativel): EChartsCoreOption {
        return {
            tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgba(38, 38, 38, 1)',
                textStyle: {
                    color: '#fff',
                },
                padding: [2, 10, 2, 10],
                borderRadius: 10,
                borderColor: 'rgba(38, 38, 38, 1)',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: (parametro: any) => {
                    const urban = parametro.find((p: any) => p.seriesName === 'urbana');
                    const rural = parametro.find((p: any) => p.seriesName === 'rural');
                    return `${parametro[0].name}<br/>
                      <span style="color:${urban.color}">●</span> urbana ${this.formateValor(urban.data.total)} (${this.formateValor(urban.value)}%)<br/>
                      <span style="color:${rural.color}">●</span> rural ${this.formateValor(rural.data.total)} (${this.formateValor(rural.value)}%)`;
                }
            },
            legend: {
                data: ['urbana', 'rural'],
                icon: 'circle',
                bottom: 0,
                itemWidth: 10,
                itemHeight: 10,
                textStyle: {
                    fontSize: 16
                },
                itemGap: 40
            },
            xAxis: {
                type: 'category',
                axisTick: { show: false },
                data: [
                    'creche',
                    'pré-\nescola',
                    'EF-anos\niniciais',
                    'EF-anos\nfinais',
                    'ensino\nmédio',
                    'EJA',
                ],
                axisLabel: {
                    interval: 0,
                    fontSize: 12,
                },
                axisLine: {
                    show: false
                }
            },
            yAxis: {
                show: false
            },
            series: [
                {
                    name: 'urbana',
                    type: 'bar',
                    stack: 'total',
                    itemStyle: {
                        color: 'rgba(255, 107, 132, 1)',
                        borderRadius: [0, 0, 5, 5],
                    },
                    data: [
                        {
                            value: this.calculePorcentagem(parametros.crecheUrbana,
                                resultadoEtapa1.creche),
                            total: parametros.crecheUrbana
                        },
                        {
                            value: this.calculePorcentagem(parametros.preEscolaUrbana,
                                resultadoEtapa1.preEscola),
                            total: parametros.preEscolaUrbana
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensFunAnosIniciaisUrbana,
                                resultadoEtapa1.ensFunAnosIniciais),
                            total: parametros.ensFunAnosIniciaisUrbana
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensFunAnosFinaisUrbana,
                                resultadoEtapa1.ensFunAnosFinais),
                            total: parametros.ensFunAnosFinaisUrbana
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensMedioUrbana,
                                resultadoEtapa1.ensMedio),
                            total: parametros.ensMedioUrbana
                        },
                        {
                            value: this.calculePorcentagem(parametros.ejaUrbana,
                                resultadoEtapa1.eja),
                            total: parametros.ejaUrbana
                        },
                    ],
                    label: {
                        show: true,
                        color: '#fff',
                        position: 'insideTop',
                        formatter: (parametro: any) => {
                            return (parametro.value > 5 ? `${this.formateValor(parametro.value)}%` : '')
                        },
                        fontSize: 12
                    },
                },
                {
                    name: 'rural',
                    type: 'bar',
                    stack: 'total',
                    data: [
                        {
                            value: this.calculePorcentagem(parametros.crecheRural,
                                resultadoEtapa1.creche),
                            total: parametros.crecheRural
                        },
                        {
                            value: this.calculePorcentagem(parametros.preEscolaRural,
                                resultadoEtapa1.preEscola),
                            total: parametros.preEscolaRural
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensFunAnosIniciaisRural,
                                resultadoEtapa1.ensFunAnosIniciais),
                            total: parametros.ensFunAnosIniciaisRural
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensFunAnosFinaisRural,
                                resultadoEtapa1.ensFunAnosFinais),
                            total: parametros.ensFunAnosFinaisRural
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensMedioRural,
                                resultadoEtapa1.ensMedio),
                            total: parametros.ensMedioRural
                        },
                        {
                            value: this.calculePorcentagem(parametros.ejaRural,
                                resultadoEtapa1.eja),
                            total: parametros.ejaRural
                        },
                    ],
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: (parametro: any) => {
                            return (parametro.value > 5 ? `${this.formateValor(parametro.value)}%` : '')
                        },
                        fontSize: 12
                    },
                    itemStyle: {
                        color: 'rgba(181, 221, 62, 1)',
                        borderRadius: [5, 5, 0, 0],
                    },
                }
            ]
        };
    }

    static crieConfiguracaoGraficoMatriculasPorTurno(parametros: ParametrosGraficoMatriculasPorTurno,
        resultadoEtapa1: ResultadoMatriculasEtapaCompativel
    ): EChartsCoreOption {
        return {
            tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgba(38, 38, 38, 1)',
                textStyle: {
                    color: '#fff',
                },
                padding: [2, 10, 2, 10],
                borderRadius: 10,
                borderColor: 'rgba(38, 38, 38, 1)',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: (parametro: any) => {
                    const parcial = parametro.find((p: any) => p.seriesName === 'parcial');
                    const integral = parametro.find((p: any) => p.seriesName === 'integral');
                    const noturna = parametro.find((p: any) => p.seriesName === 'noturna');
                    return `${parametro[0].name}<br/>
                              <span style="color:${parcial.color}">●</span> parcial ${this.formateValor(parcial.data.total)} (${this.formateValor(parcial.value)}%)<br/>
                              <span style="color:${integral.color}">●</span> integral ${this.formateValor(integral.data.total)} (${this.formateValor(integral.value)}%)<br/>
                              <span style="color:${noturna.color}">●</span> noturna ${this.formateValor(noturna.data.total)} (${this.formateValor(noturna.value)}%)`;
                }
            },
            legend: {
                data: ['parcial', 'integral', 'noturna'],
                icon: 'circle',
                bottom: 0,
                itemWidth: 10,
                itemHeight: 10,
                textStyle: {
                    fontSize: 16,
                },
                itemGap: 40
            },
            xAxis: {
                type: 'category',
                axisTick: { show: false },
                data: [
                    'creche\n(<1 ano)',
                    'pré-\nescola',
                    'EF-anos\niniciais',
                    'EF-anos\nfinais',
                    'ensino\nmédio',
                    'EJA',
                ],
                axisLabel: {
                    interval: 0,
                    fontSize: 12,
                },
                axisLine: {
                    show: false
                }
            },
            yAxis: {
                show: false
            },
            series: [
                {
                    name: 'parcial',
                    type: 'bar',
                    stack: 'total',
                    itemStyle: {
                        color: 'rgba(204, 235, 107, 1)',
                        borderRadius: [0, 0, 5, 5],
                    },
                    data: [
                        {
                            value: this.calculePorcentagem(parametros.crecheParcial,
                                resultadoEtapa1.creche),
                            total: parametros.crecheParcial
                        },
                        {
                            value: this.calculePorcentagem(parametros.preEscolaParcial,
                                resultadoEtapa1.preEscola),
                            total: parametros.preEscolaParcial
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensFunAnosIniciaisParcial,
                                resultadoEtapa1.ensFunAnosIniciais),
                            total: parametros.ensFunAnosIniciaisParcial
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensFunAnosFinaisParcial,
                                resultadoEtapa1.ensFunAnosFinais),
                            total: parametros.ensFunAnosFinaisParcial
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensMedioParcial,
                                resultadoEtapa1.ensMedio),
                            total: parametros.ensMedioParcial
                        },
                        {
                            value: this.calculePorcentagem(parametros.ejaParcial,
                                resultadoEtapa1.eja),
                            total: parametros.ejaParcial
                        },
                    ],
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: (parametro: any) => {
                            return (parametro.value > 5 ? `${this.formateValor(parametro.value)}%` : '')
                        },
                        fontSize: 12
                    },
                },
                {
                    name: 'integral',
                    type: 'bar',
                    stack: 'total',
                    data: [
                        {
                            value: this.calculePorcentagem(parametros.crecheIntegral,
                                resultadoEtapa1.crecheUrbanaIntegral),
                            total: parametros.crecheIntegral
                        },
                        {
                            value: this.calculePorcentagem(parametros.preEscolaIntegral,
                                resultadoEtapa1.preEscola),
                            total: parametros.preEscolaIntegral
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensFunAnosIniciaisIntegral,
                                resultadoEtapa1.ensFunAnosIniciais),
                            total: parametros.ensFunAnosIniciaisIntegral
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensFunAnosFinaisIntegral,
                                resultadoEtapa1.ensFunAnosFinais),
                            total: parametros.ensFunAnosFinaisIntegral
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensMedioIntegral,
                                resultadoEtapa1.ensMedio),
                            total: parametros.ensMedioIntegral
                        },
                        {
                            value: this.calculePorcentagem(parametros.ejaIntegral,
                                resultadoEtapa1.eja),
                            total: parametros.ejaIntegral
                        },
                    ],
                    label: {
                        show: true,
                        position: 'insideTop',
                        formatter: (parametro: any) => {
                            return (parametro.value > 5 ? `${this.formateValor(parametro.value)}%` : '')
                        },
                        fontSize: 12
                    },
                    itemStyle: {
                        color: 'rgba(255, 148, 57, 1)',
                        borderRadius: [0, 0, 0, 0],
                    },
                },
                {
                    name: 'noturna',
                    type: 'bar',
                    stack: 'total',
                    data: [
                        {
                            value: this.calculePorcentagem(parametros.crecheNoturna,
                                0),
                            total: parametros.crecheNoturna
                        },
                        {
                            value: this.calculePorcentagem(parametros.preEscolaNoturna,
                                resultadoEtapa1.preEscola),
                            total: parametros.preEscolaNoturna
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensFunAnosIniciaisNoturna,
                                resultadoEtapa1.ensFunAnosIniciais),
                            total: parametros.ensFunAnosIniciaisNoturna
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensFunAnosFinaisNoturna,
                                resultadoEtapa1.ensFunAnosFinais),
                            total: parametros.ensFunAnosFinaisNoturna
                        },
                        {
                            value: this.calculePorcentagem(parametros.ensMedioNoturna,
                                resultadoEtapa1.ensMedio),
                            total: parametros.ensMedioNoturna
                        },
                        {
                            value: this.calculePorcentagem(parametros.ejaNoturna,
                                resultadoEtapa1.eja),
                            total: parametros.ejaNoturna
                        },
                    ],
                    label: {
                        show: true,
                        color: "#fff",
                        position: 'insideTop',
                        formatter: (parametro: any) => {
                            return (parametro.value > 5 ? `${this.formateValor(parametro.value)}%` : '')
                        },
                        fontSize: 12
                    },
                    itemStyle: {
                        color: 'rgba(54, 185, 250, 1)',
                        borderRadius: [5, 5, 0, 0],
                    },
                }
            ]
        };
    }

    static formateValor(valor: number) {
        return new Intl.NumberFormat('pt-BR').format(valor);
    }

    static calculePorcentagem(valor: number, total: number): number {
        return total > 0 ?
            +((valor / total) * 100).toFixed(1) : 0;
    }
}